import React from 'react';

export default function MobileHeader({ prenom, restaurant, onSelectRestaurant }) {
  return (
    <header style={styles.wrapper}>
      <div style={styles.inner}>
        <h1 style={styles.greeting}>
          Bonjour {prenom || ''} <span aria-hidden>👋</span>
        </h1>
        <button
          type="button"
          style={styles.selector}
          onClick={() => {
            if (typeof onSelectRestaurant === 'function') onSelectRestaurant();
            else console.log('[MobileHeader] tap restaurant selector — bottom sheet en Session 5');
          }}
          aria-label="Changer de restaurant"
        >
          <span style={styles.icon} aria-hidden>🏠</span>
          <span style={styles.restoLabel}>
            {restaurant?.nom || 'Restaurant'}
            {restaurant?.ville ? ` · ${restaurant.ville}` : ''}
          </span>
          <span style={styles.chevron} aria-hidden>⌄</span>
        </button>
      </div>
    </header>
  );
}

const styles = {
  wrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    background: 'rgba(237, 234, 227, 0.92)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    paddingTop: 'env(safe-area-inset-top)',
    borderBottom: '1px solid rgba(0,0,0,0.04)',
  },
  inner: {
    padding: '12px 16px 14px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  greeting: {
    margin: 0,
    fontSize: 28,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '-0.01em',
  },
  selector: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: '#FFFFFF',
    border: '1px solid #E5E5E0',
    borderRadius: 999,
    padding: '8px 14px',
    width: 'fit-content',
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    color: '#1A1A1A',
    cursor: 'pointer',
  },
  icon: {
    fontSize: 14,
    lineHeight: 1,
  },
  restoLabel: {
    color: '#1A1A1A',
  },
  chevron: {
    fontSize: 14,
    color: '#6B6B6B',
    marginLeft: 2,
    lineHeight: 1,
  },
};
